import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  open: false,
  messsage: '',
  variant: 'info',
  progress: null,
  duration: 3000,
}

export const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    openBar: (state, action) => {
      return {
        ...state,
        open: true,
        message: action.payload.message,
        variant: action.payload.variant,
        // progress: action.payload.progress,
        // duration: action.payload.duration,
      }
    },
    closeBar: (state, action) => {
      return {
        ...state,
        open: false,
        message: '',
      }
    },
  },
})

export const { openBar, closeBar } = snackbarSlice.actions
export default snackbarSlice.reducer
